import { useTranslation } from 'next-i18next'

import { Icon } from '~/components/Icon'
import { useAppSelector } from '~/redux/hooks'

import { selectServerError } from '../redux/settings.slice'

export default function ServerError(): React.ReactElement {
  const { t } = useTranslation(['errors'])

  const serverError = useAppSelector(selectServerError)

  return (
    <div>
      {serverError && (
        <div className="mt-8 py-2 px-4 self-start flex items-center rounded bg-gray-light text-red">
          <Icon className="text-red mr-2" name="error_outline" />
          {t(`errors:${serverError}` as const)}
        </div>
      )}
    </div>
  )
}
